export default "__VITE_ASSET__2652ltWm__"